export enum Routes {
  Root = '/',
  SignUp = 'opprett-ny-konto',
  Terms = '/vilkar',
  OnboardingRole = '/kom-i-gang/rolle',
  OnboardingGoal = '/kom-i-gang/mal',
  DataProcessingAgreement = '/databehandleravtale',
  ForgotPassword = 'forgot-password',
  ExpiredTrial = '/expired-trial',
  Dashboard = '/dashboard',
  DashboardPsychologicalSafety = '/dashboard/team-dynamics',
  DashboardWorkEnvironment = '/dashboard/work-environment',
  DashboardWorkEnvironmentSurvey = '/dashboard/work-environment/:surveyId',
  WorkEnvironmentReport = '/dashboard/work-environment/:surveyId/report',
  WorkEnvironmentInspectionReport = '/dashboard/work-environment/:surveyId/inspection-report',
  DashboardCustomSurveys = '/dashboard/custom-surveys',
  DashboardCustomSurveyTemplateTrends = '/dashboard/custom-surveys/template/:templateId',
  DashboardCustomSurveySurvey = '/dashboard/custom-surveys/template/:templateId/survey/:surveyId',
  Teams = '/teams',
  CreateTeam = '/teams/create',
  Team = '/teams/:teamId/setup',
  TeamAccessManagement = '/teams/:teamId/access-management',
  TeamIntegration = '/teams/:teamId/integration',
  TeamScheduling = '/teams/:teamId/scheduling',
  FormSubmission = '/survey/:guid',
  WorkEnvironmentFormSubmission = '/work-environment-survey/:guid',
  CustomSurveyFormSubmission = '/custom-survey/:guid',
  WorkEnvironmentActionProposal = '/work-environment-actions/:guid',
  WorkEnvironmentActionVoting = '/work-environment-voting/:guid',
  WorkEnvironmentTeamPage = '/work-environment-team/:guid',
  PublicTeamHealthMetrics = '/results/:guid',
  PublicActionPlanDirect = '/results/:guid/action-plan',
  Verify = '/verifisere-din-konto',
  AnalyzeSurvey = '/teams/:teamId/analyze-survey/:surveyId/:pageQuestionIndex',
  AnalyzeSurveySummary = '/teams/:teamId/analyze-survey/:surveyId/summary',
  InterpretiveReport = '/dashboard/team/:teamId/interpretive-report/:surveyId',
  Surveys = '/surveys',
  CreateSurvey = '/surveys/create',
  CurrentSurveys = '/surveys/current',
  PlannedSurveys = '/surveys/planned',
  EditPlannedSurvey = '/surveys/planned/edit/:id',
  Settings = '/settings',
  UserSettings = '/settings/user',
  UserPrivacy = '/settings/privacy',
  ContentManagementSystemArticles = '/content-system/articles',
  ContentManagementSystemArticle = '/content-system/articles/:id',
  ContentManagementSystemCreateArticle = '/content-system/articles/create',
  ContentManagementSystemEditArticle = '/content-system/articles/edit/:id',
  HRDashboard = '/hr/dashboard',
  HRHome = 'home',
  HRHomeFullPath = '/hr/dashboard/home',
  HRPsychologicalSafety = 'team-dynamics',
  HRPsychologicalSafetyFullPath = '/hr/dashboard/team-dynamics',
  HRRiskMatrix = 'risk-matrix',
  HRRiskMatrixFullPath = '/hr/dashboard/risk-matrix',
  HRRiskFactors = 'risk-matrix/factors',
  HRRiskFactorsFullPath = '/hr/dashboard/risk-matrix/factors',
  HRSafetyRoundOverview = 'vernerunder/oversikt',
  HRSafetyRoundOverviewFullPath = '/hr/dashboard/vernerunder/oversikt',
  HRSafetyRoundChecklists = 'vernerunder/maler',
  HRSafetyRoundChecklistsFullPath = '/hr/dashboard/vernerunder/maler',
  HRSafetyRoundChecklist = 'vernerunder/maler/:checklistId',
  HRSafetyRoundChecklistFullPath = '/hr/dashboard/vernerunder/maler/:checklistId',
  SafetyRepOverview = '/verneombud',
  SafetyRepRoundPlans = '/verneombud/vernerunder',
  SafetyRepRoundPlanNew = '/verneombud/vernerunder/ny',
  SafetyRepRoundPlan = '/verneombud/vernerunder/plan/:planId',
  SafetyRepRoundPlanChecklist = '/verneombud/vernerunder/plan/:planId/sjekkliste',
  SafetyRepRound = '/verneombud/vernerunder/runde/:roundId',
  SafetyRepRoundProtocol = '/verneombud/vernerunder/runde/:roundId/protokoll',
  Deviation = '/avvik/:deviationId',
  MyDeviations = '/mine-avvik',
  Notifications = '/varsler',
  GeneralManagerTasks = '/daglig-leder/oppgaver',
  GeneralManagerSafetyRoundOverview = '/daglig-leder/vernerunder',
  GeneralManagerProtocol = '/daglig-leder/protokoll/:roundId',
  GeneralManagerPlan = '/daglig-leder/vernerunder/plan/:planId',
  GeneralManagerRound = '/daglig-leder/vernerunder/runde/:roundId',
  GeneralManagerNotifications = '/daglig-leder/varsler',
  SafetyRoundNotifications = '/verneombud/vernerunder/varsler',
  SafetyRoundOverview = '/verneombud/vernerunder/oversikt',
  SafetyRoundLogPdf = '/verneombud/vernerunder/logg/pdf',
  SafetyRepTeams = '/verneombud/team',
  SafetyRepNotifications = '/verneombud/varsler',
  SafetyRepSurvey = '/verneombud/team/:surveyId',
  SafetyRepReport = '/verneombud/team/:surveyId/report',
  SafetyRepInspectionReport = '/verneombud/team/:surveyId/inspection-report',
  SafetyRepSigning = '/verneombud/signering',
  SafetyRepCompleted = '/verneombud/signering/fullfort/:taskKey',
  SafetyRepRiskMatrixVersion = '/verneombud/signering/risikomatrise/:versionId',
  SafetyRepTemplateVersion = '/verneombud/signering/risikofaktorer/:versionId',
  HRWorkEnvironment = 'work-environment',
  HRWorkEnvironmentFullPath = '/hr/dashboard/work-environment',
  HRWorkEnvironmentMeasures = 'work-environment/measures',
  HRWorkEnvironmentMeasuresFullPath = '/hr/dashboard/work-environment/measures',
  HRWorkEnvironmentMissingSafetyReps = 'work-environment/teams-without-safety-representative',
  HRWorkEnvironmentMissingSafetyRepsFullPath = '/hr/dashboard/work-environment/teams-without-safety-representative',
  HRWorkEnvironmentSurveysDue = 'work-environment/surveys-due',
  HRWorkEnvironmentSurveysDueFullPath = '/hr/dashboard/work-environment/surveys-due',
  HRWorkEnvironmentRequirements = 'work-environment/requirements',
  HRWorkEnvironmentRequirementsFullPath = '/hr/dashboard/work-environment/requirements',
  HRWorkEnvironmentProcess = 'work-environment/process',
  HRWorkEnvironmentProcessFullPath = '/hr/dashboard/work-environment/process',
  HRWorkEnvironmentRisks = 'work-environment/risks',
  HRWorkEnvironmentRisksFullPath = '/hr/dashboard/work-environment/risks',
  HRWorkEnvironmentTeams = 'work-environment/teams',
  HRWorkEnvironmentTeamsFullPath = '/hr/dashboard/work-environment/teams',
  HRSafetyReps = 'work-environment/safety-representatives',
  HRSafetyRepsFullPath = '/hr/dashboard/work-environment/safety-representatives',
  HRWorkEnvironmentSurveyDetail = 'work-environment/survey/:surveyId',
  HRWorkEnvironmentSurveyDetailFullPath = '/hr/dashboard/work-environment/survey/:surveyId',
  HRWorkEnvironmentReport = '/hr/dashboard/work-environment/survey/:surveyId/report',
  HRWorkEnvironmentInspectionReport = '/hr/dashboard/work-environment/survey/:surveyId/inspection-report',
  OrganizationSettings = '/organization/settings',
  OrganizationBusiness = '/organization/business',
  OrganizationGeneral = '/organization/general',
  OrganizationTeamsOverview = '/organization/teams',
  OrganizationCreateTeam = '/organization/teams/create',
  OrganizationUsersOverviewPage = '/organization/users',
  OrganizationInviteUser = '/organization/users/invite',
  OrganizationViewUser = '/organization/users/view/:userId',
  OrganizationEditUser = '/organization/users/edit/:userId',
  OrganizationTeam = '/organization/teams/:teamId/setup',
  OrganizationTeamScheduling = '/organization/teams/:teamId/scheduling',
  OrganizationScheduling = '/organization/scheduling',
  OrganizationSubscriptions = '/organization/subscriptions',
  OrganizationUsage = '/organization/usage',
  OrganizationUsageTeamDetails = '/organization/usage/:teamId',
  QuestionTrends = '/teams/:teamId/question-trends',
  SystemAdmin = '/system-admin',
  SystemAdminDashboard = '/system-admin/dashboard',
  SystemAdminTenants = '/system-admin/tenants',
  SystemAdminCreateTenant = '/system-admin/tenants/create',
  SystemAdminTenantDetail = '/system-admin/tenants/:tenantId',
  SystemAdminTenantFeatures = '/system-admin/tenants/:tenantId/features',
  SystemAdminEditSmsQuota = '/system-admin/tenants/:tenantId/edit-sms-quota',
  SystemAdminEditSeats = '/system-admin/tenants/:tenantId/edit-seats',
  SystemAdminUpgradeTenantToPartner = '/system-admin/tenants/:tenantId/upgrade-to-partner',
  SystemAdminPartners = '/system-admin/partners',
  SystemAdminPartnerDetail = '/system-admin/partners/:partnerId',
  SystemAdminEditPartner = '/system-admin/partners/:partnerId/edit',
  SystemAdminCreatePartner = '/system-admin/partners/create',
  SystemAdminPartnerLeadsOverview = '/system-admin/partner-leads/overview',
  SystemAdminUserDetail = '/system-admin/users/:userId',
  PartnerAdmin = '/partner-admin',
  PartnerAdminDashboard = '/partner-admin/dashboard',
  PartnerAdminCustomers = '/partner-admin/customers',
  PartnerAdminCreateCustomer = '/partner-admin/customers/create',
  PartnerAdminCustomerDetail = '/partner-admin/customers/:customerId',
  PartnerAdminLeads = '/partner-admin/leads',
  PartnerAdminCreateLead = '/partner-admin/leads/create',
  PartnerAdminLeadDetail = '/partner-admin/leads/:leadId',
  PartnerAdminEditLead = '/partner-admin/leads/:leadId/edit',
  PartnerAdminCashback = '/partner-admin/cashback',
  PartnerAdminSettings = '/partner-admin/settings',
  TeamsOAuthCallback = '/integrations/teams/callback',
  SlackOAuthCallback = '/slack-oauth-callback',
  CustomSurveyTemplates = '/custom-survey-templates',
  CreateCustomSurveyTemplate = '/custom-survey-templates/create',
  CustomSurveyTemplateDetail = '/custom-survey-templates/:templateId',
  EditCustomSurveyTemplate = '/custom-survey-templates/:templateId/edit',
  DashboardCustomSurveyResponseDetail = '/dashboard/custom-surveys/template/:templateId/survey/:surveyId/response/:responseId',
}